import { render } from "./FormAanpakView.vue?vue&type=template&id=4ad147a2&scoped=true"
import script from "./FormAanpakView.vue?vue&type=script&lang=js"
export * from "./FormAanpakView.vue?vue&type=script&lang=js"

import "./FormAanpakView.vue?vue&type=style&index=0&id=4ad147a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad147a2"]])

export default __exports__